import { render, staticRenderFns } from "./stats-badge-state.vue?vue&type=template&id=449a6d5c&"
import script from "./stats-badge-state.vue?vue&type=script&lang=js&"
export * from "./stats-badge-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports